/**
 * Reading the brief round-table's wrap-up marker off a conversation-message's `metadata`.
 *
 * The harness stamps `agentMeetingSummary` as a JSON bool on some rows and as a stringified
 * `"true"` on others (the wire is a `map<string,string>`), so a strict `=== true` silently misses
 * the string form. Mirrors iOS `SymphonyAPI.agentMeetingSummary` / Android `parseAgentMeetingSummary`
 * and the client-local `isBriefSummaryTurn` in `lib/brief.ts`.
 *
 * Lives in its own module with no runtime imports so both the client (`use-chat`) and the server
 * (`/api/conversations/[id]/messages`) can read it, and it can be unit-tested without dragging the
 * app's dependency graph (see CLAUDE.md → Tests).
 */
export function readMeetingSummaryFlag(value: unknown): boolean {
  return value === true || (typeof value === 'string' && value.toLowerCase() === 'true');
}
